import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';

export default function NotFoundPage() {
  const { t } = useLanguage();

  return (
    <div
      className="min-h-screen bg-slate-100 pt-20 flex items-center justify-center px-4 py-16"
      data-testid="not-found-page"
    >
      <div className="max-w-lg text-center">
        <p className="text-sm font-semibold uppercase tracking-wider text-signal-blue mb-2">
          404
        </p>
        <h1 className="font-heading text-3xl sm:text-4xl font-bold text-slate-800 mb-3">
          {t('notfound.title', 'Page not found')}
        </h1>
        <p className="text-slate-600 mb-8">
          {t(
            'notfound.message',
            'The page you requested is not available. Try home or search listings to continue.',
          )}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button asChild className="bg-signal-blue hover:bg-signal-blue-hover text-white">
            <Link to="/">
              <Home className="w-4 h-4 mr-2" />
              {t('notfound.back_home', 'Back to home')}
            </Link>
          </Button>
          <Button asChild variant="outline" className="border-slate-300 text-slate-700">
            <Link to="/listings">
              <Search className="w-4 h-4 mr-2" />
              {t('notfound.browse_listings', 'Browse listings')}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
